// Pick, change or remove the business logo. Images are scaled down to fit.
import { useId, useRef, useState } from 'react';
import { businessInitials } from '@/core/business';
import { t } from '@/l10n/strings';
import { logoFromFile } from '@/utils/images';
import { Avatar, Button } from '@/ui/controls';

export function LogoPicker({ logo, name, onChange }: { logo: string | null; name: string; onChange: (logo: string | null) => void }) {
  const input = useRef<HTMLInputElement>(null);
  const id = useId();
  const [error, setError] = useState<string | null>(null);
  return (
    <div className="stack-2">
      <div className="row" style={{ gap: 16 }}>
        <Avatar initials={businessInitials(name)} image={logo} size="lg" />
        <Button size="sm" icon="image" onClick={() => input.current?.click()} aria-describedby={error ? `${id}-error` : undefined}>
          {logo ? t('commonChangeLogo') : t('commonAddLogo')}
        </Button>
        {logo && (
          <button type="button" className="link-btn link-btn--danger" onClick={() => onChange(null)}>
            {t('commonRemoveLogo')}
          </button>
        )}
        <input
          ref={input}
          type="file"
          accept="image/png,image/jpeg,image/webp,image/svg+xml"
          hidden
          onChange={async (e) => {
            const file = e.target.files?.[0];
            e.target.value = '';
            if (!file) return;
            setError(null);
            try {
              const uri = await logoFromFile(file);
              if (uri) onChange(uri);
              else setError(t('errorLogoTooBig'));
            } catch {
              setError(t('errorLogoTooBig'));
            }
          }}
        />
      </div>
      {error && (
        <span className="error" id={`${id}-error`} role="alert">
          {error}
        </span>
      )}
    </div>
  );
}
